import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import './Tooltip.css';

const TooltipElement = ({ ...props }) => <Tooltip {...props} />;

export default TooltipElement;
